import React from 'react';
import Header from '../components/Header';
import Section from '../components/Section'; 
import MaterialContainer from '../containers/Materials.container';
import CalendarContainer from '../containers/Calendar.container';

const Materials = () => (
    <React.Fragment>
        <Header mod={'page__header_materials'} />
        <Section
            title="Расписание"
            button={{ href: '/olympic2018/kalendar-olimpiada-2018#', text: 'Полное расписание' }}
            mod={'slide'}
        >
            <CalendarContainer limits={4} />
        </Section >
        <Section
            title="Материалы"
        >
            <MaterialContainer mlimits={12} nlimits={12} button={{ text: 'Читать еще' }} fullpage={1} />
        </Section>
    </React.Fragment>
);

export default Materials;



// WEBPACK FOOTER //
// ./src/pages/Materials.jsx